<template>
  <div class="p-[20px] border border-solid border-steam rounded-[8px] vs-con-loading__container" id="packages-section-loading">
    <div class="flex justify-between items-center">
      <div class="flex gap-2 items-center">
        <span class="material-symbols-outlined text-industrial-revolution text-[24px]">box</span>
        <p class="text-young-night text-lg">{{ $t('Packages') }}</p>
      </div>
      <div v-if="$store.state.AppActiveUser.userRole === 'merchant' && merchantStatus === 'active' && (common.defineOrderType(orderData) === 'returns' && common.getPermissions('return_orders').base.includes('update') || common.defineOrderType(orderData) === 'delivery-orders' && common.getPermissions('delivery_orders').base.includes('update'))">
        <div class="flex" v-if="orderData.status === 'created' || orderData.status === 'return_requested' || orderData.status === 'pickup_requested'">
          <feather-icon icon="EditIcon" svgClasses="h-6 w-6" class="text-silver cursor-pointer" 
            v-if="!editable" @click="editInformation()" />
        </div>
      </div>
      <div class="flex" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'head-of-fleet' || $store.state.AppActiveUser.userRole === 'customer-support'">
        <feather-icon icon="EditIcon" svgClasses="h-6 w-6" class="text-silver cursor-pointer" 
          v-if="!editable && !(orderData.status === 'delivered' || orderData.status === 'returned' || orderData.status === 'returned_to_origin' || orderData.status === 'cancelled')" @click="editInformation()" />
      </div>
    </div>
    <div class="mt-4">
      <div v-if="!editable" class="flex justify-between items-center mb-4">
        <div class="flex-col gap-[6px] w-1/2">
          <p class="text-young-night">{{ $t('Number of packages') }}</p>
          <p class="text-industrial-revolution">{{ orderData.number_of_packages }}</p>
        </div>
        <div class="flex-col gap-[6px] w-1/2">
          <p class="text-young-night">{{ $t('Package size') }}</p>
          <p class="text-industrial-revolution">{{ packageObj.packagesSizes.map((item) => (item.count > 0) && item.name.includes('Small') ? 'S' : (item.count > 0) && item.name.includes('40x35cm') ? 'M' : (item.count > 0) && item.name.includes('45x50cm') ? 'L' : (item.count > 0) && item.name.includes('50x60cm') ? 'Xl' : '').filter(item => item !== '').join(', ')}}</p>
        </div>
      </div>
      <div class="flex justify-between items-center mb-5">
        <div v-if="!editable" class="flex-col gap-[6px] w-1/2">
          <p class="text-young-night">{{ $t('Allow to open') }}</p>
          <p v class="text-industrial-revolution">{{ orderData.is_customer_allowed_to_open_packages && orderData.is_customer_allowed_to_open_packages === true ? 'Yes' : 'No' }}</p>
        </div>
        <shipblu-select :disabled="$store.state.AppActiveUser.userRole === 'head-of-fleet'" :key="openPackageKey" :inputValue="orderData.is_customer_allowed_to_open_packages && orderData.is_customer_allowed_to_open_packages === true ? allowedToOpenOptions[0] : allowedToOpenOptions[1]" class="w-1/2 mr-3" v-show="editable" :options="allowedToOpenOptions" input-id="input-option" :localize="true" optionLabel="name" :labelPlaceholder="$t('Allow to open')" @selectedOptions="orderData.is_customer_allowed_to_open_packages = $event[0]" name="option"></shipblu-select>
        <div v-if="!editable" class="flex-col gap-[6px] w-1/2">
          <p class="text-young-night">{{ $t('Fragile') }}</p>
          <p class="text-industrial-revolution">{{fragileSelected.name}}</p>
        </div>
        <shipblu-select :disabled="$store.state.AppActiveUser.userRole === 'head-of-fleet'" :key="fragileKey" :inputValue="fragileSelected" class="w-1/2" v-show="editable" :options="fragileOptions" input-id="input-option" :localize="true" optionLabel="name" :labelPlaceholder="$t('Fragile')" @selectedOptions="selectFragile($event)" name="option"></shipblu-select>
      </div>
      <div v-if="editable" class="mb-5">
        <div class="flex flex-col gap-3">
          <div v-for="(item, index) in packageObj.packagesSizes" :key="index">
            <div :class="`border border-solid ${item.count > 0 ? 'border-primary' : 'border-stoic-white'} rounded flex justify-between overflow-hidden`">
              <div class="flex items-center gap-3">
                <div class="rounded px-5 py-2 flex items-center bg-beluga">
                  <img src="@/assets/images/pages/flyer.svg" class="w-10" alt="flyer">
                </div>
                <div class="text-sm text-black">
                  <p class="inline">{{ $t(item.name.match(/^.*?(?=\s?\()/)[0]) }}</p>
                  <p v-if="item.count > 0" class="text-primary inline">{{ ' (' + item.count + ')' }}</p>
                  <p>{{ $t(item.name.match(/\(.*\)/)[0]) }}</p>
                </div>
              </div>
              <button v-if="item.count === 0" :disabled="numberOfPackages() >= 4" @click="changePackageCount(index, 'increase')" :class="`${numberOfPackages() >= 4 ? 'bg-grey-light text-grey' : 'bg-primary text-white'} self-center mx-3 p-1 outline-none border-0 cursor-pointer rounded-sm flex items-center justify-center`">
                <span class="material-symbols-outlined text-xl">add</span>
              </button>
              <div v-else class="grid grid-cols-1 border-0 border-l border-solid border-silver">
                <button :disabled="numberOfPackages() >= 4" @click="changePackageCount(index, 'increase')" class="bg-transparent px-3 outline-none border-0 border-b border-solid border-silver cursor-pointer flex items-center justify-center">
                  <span :class="`material-symbols-outlined text-xl ${numberOfPackages() >= 4 ? 'text-grey' : 'text-primary'}`">add</span>
                </button>
                <button :disabled="numberOfPackages() <= 0" @click="changePackageCount(index, 'decrease')" class="bg-transparent px-3 outline-none border-0 cursor-pointer flex items-center justify-center">
                  <span :class="`material-symbols-outlined text-xl ${numberOfPackages() <= 0 ? 'text-grey' : 'text-primary'}`">remove</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex-col gap-[6px] w-full">
        <p class="text-young-night">{{ $t('Description') }}</p>
        <p v-if="!editable" class="break-words">{{ orderDescription }}</p>
        <textarea :disabled="$store.state.AppActiveUser.userRole === 'head-of-fleet'" v-if="editable" v-model="orderDescription" class="w-full mt-1 resize-none p-3 rounded bg-transparent border border-solid border-compact-disc-grey outline-none"></textarea>
      </div>
    </div>
    <div v-if="$store.state.AppActiveUser.userRole === 'merchant'">
      <div class="flex gap-4 items-center" v-if="orderData.status === 'created'|| orderData.status === 'pickup_requested' || orderData.status === 'return_requested'">
        <vx-tooltip v-if="orderData.number_of_packages > packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" class="w-1/2" position="top" color="warning" :text="`${$t('You can\'t reduce the number of packages, please either add or update the packages choosen ')}`">
          <vs-button :disabled="orderData.number_of_packages > packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" class="mt-6 font-semibold rounded w-full" v-if="editable" @click="updatePackages()">{{$t('Save')}}</vs-button>
        </vx-tooltip>
        <vs-button class="mt-6 font-semibold rounded w-1/2" v-if="editable && orderData.number_of_packages <= packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" @click="updatePackages()">{{$t('Save')}}</vs-button>
        <vs-button class="mt-6 font-semibold rounded w-1/2 bg-polished-metal" v-if="editable" @click="cancelPackageInfoEdit()">{{$t('Cancel')}}</vs-button>
      </div>
    </div>
    <div class="flex gap-4 items-center" v-else-if="$store.state.AppActiveUser.userRole === 'admin' || $store.state.AppActiveUser.userRole === 'head-of-fleet' || $store.state.AppActiveUser.userRole === 'customer-support'">
      <vx-tooltip v-if="orderData.number_of_packages > packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" class="w-1/2" position="top" color="warning" :text="`${$t('You can\'t reduce the number of packages, please either add or update the packages choosen ')}`">
        <vs-button :disabled="orderData.number_of_packages > packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" class="mt-6 font-semibold rounded w-full" v-if="editable"  @click="updatePackages()">{{$t('Save')}}</vs-button>
      </vx-tooltip>
      <vs-button class="mt-6 font-semibold rounded w-1/2" v-if="editable && orderData.number_of_packages <= packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)" @click="updatePackages()">{{$t('Save')}}</vs-button>
      <vs-button class="mt-6 font-semibold rounded w-1/2" v-if="editable" @click="cancelPackageInfoEdit()">{{$t('Cancel')}}</vs-button>
    </div>
  </div>
</template>

<script>
import {sendRequest} from '@/http/axios/requestHelper.js'
import i18nData from '../../../i18n/i18nData'
import common from '../../../assets/utils/common'
import ShipbluCard from '@/layouts/components/ShipbluCard.vue'

export default {
  props: ['orderData', 'merchantStatus'],
  data () {
    return {
      common,
      localStorage,
      editable: false,
      packagesObjectCount: [],
      allowedToOpenOptions: [
        {
          id: 1,
          name: 'Yes',
          value: true
        },
        {
          id: 2,
          name: 'No',
          value: false
        }
      ],
      fragileOptions: [
        {
          id: 1,
          name: 'Yes',
          value: true
        },
        {
          id: 2,
          name: 'No',
          value: false
        }
      ],
      newOrderData:{},
      packageObj: {
        options: [],
        packagesSizes: [],
        description: ''
      },
      newAddedPackages: [],
      packageIDs: [],
      openPackageObj: {
        allowedToOpen: {
        }
      },
      orderDescription: '',
      fragileKey: 0,
      openPackageKey: 1,
      fragileSelected: {}
    }
  },
  watch: {
    'orderData' () {
      this.editable = false
      this.fragileSelected = this.orderData.packages.length > 0 ? this.orderData.packages.filter(item => { return item.package ? item.package.fragile : item.fragile }).length > 0 ? this.fragileOptions[0] : this.fragileOptions[1] : {}
      
      this.orderDescription = this.orderData.packages[0] ? this.orderData.packages[0].package.description : ''
      let packageSizeIDs = this.orderData.packages.map(item => {
        return {
          packageSizeId: item.package.package_size.id,
          packageId: item.package.id,
          fragile: item.package.fragile
        }
      })
      function count_duplicate (packageList) {
        const counts = {}
        const list = []
        for (let i = 0; i < packageList.length; i++) { 
          if (counts[packageList[i].packageSizeId]) {
            counts[packageList[i].packageSizeId] += 1
          } else {
            counts[packageList[i].packageSizeId] = 1
          }
        }  
        for (const prop in counts) {
          const packageSize = packageList.filter(item => item.packageSizeId === Number(prop)).map(item => item.packageId)
          list.push({
            id: Number(prop),
            count: counts[prop] > 1 ? counts[prop] : 1,
            packageId: packageSize,
            fragile: packageList.filter(item => item.packageSizeId === Number(prop)).map(item => item.fragile)
          })
        }
        return list
      }
      this.packagesObjectCount = count_duplicate(packageSizeIDs)
      this.packageObj.packagesSizes.forEach(packageSize => {
        const packageCount = this.packagesObjectCount.find(item => item.id === packageSize.id)
        if (packageCount) {
          packageSize.count = packageCount.count
        } else {
          packageSize.count = 0
        }
      })
      this.packagesObjectCount.forEach(packageSize => {
        if (packageSize.count > 1) {
          for (let index = 1; index < packageSize.count; index++) {
            this.orderData.packages.push({
              package_size: packageSize.id,
              count: 1,
              fragile: packageSize.fragile[0] || false,
              description: this.orderDescription
            })
          }
        } else if (packageSize.count === 1) {
          this.orderData.packages.push({
            id: packageSize.packageId[0] || null,
            package_size: packageSize.id,
            count: 1,
            fragile: packageSize.fragile[0] || false,
            description: this.orderDescription
          })
        }
      })
      this.orderData.packages = []
      packageSizeIDs = []
    }
  },
  methods: {
    selectFragile (event) {
      this.fragileSelected = event[0]
    },
    changePackageCount (packageIndex, type) {
      if (type === 'increase') {
        this.packageObj.packagesSizes[packageIndex].count += 1
      } else {
        this.packageObj.packagesSizes[packageIndex].count -= 1
      }
    },
    numberOfPackages () {
      return this.packageObj.packagesSizes.reduce((sum, item) => sum + (item.count), 0)
    },
    loadPackageSizes () {
      this.packageObj.packagesSizes = [
        {
          count: 0,
          description: 'Small Flyer (25x35cm)',
          id: 1,
          name: 'Small Flyer (25x35cm)',
          short_code: 'S-FLY'
        },
        {
          count: 0,
          description: 'Medium Flyer (40x35cm)',
          id: 2,
          name: 'Medium Flyer (40x35cm)',
          short_code: 'M-FLY'
        },
        {
          count: 0,
          description: 'Large Flyer (45x50cm)',
          id: 3,
          name: 'Large Flyer (45x50cm)',
          short_code: 'L-FLY'
        },
        {
          count: 0,
          description: 'Extra Large Flyer (50x60cm)',
          id: 4,
          name: 'Extra Large Flyer (50x60cm)',
          short_code: 'XL-FLY'
        }
      ]
    },
    editInformation () {
      this.editable = true
      this.fragileKey += 4
      this.openPackageKey += 2
    },
    updatePackages () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            background: this.backgroundLoading,
            color: this.colorLoading,
            container: '#packages-section-loading',
            scale: 0.45
          })
          let orderPackages = []
          // Collect all existing package IDs into a flat array
          this.packagesObjectCount.forEach(item => {
            if (Array.isArray(item.packageId)) {
              orderPackages.push(...item.packageId)
            } else {
              orderPackages.push(item.packageId)
            }
          })
          orderPackages = orderPackages.flat() // Ensure it's a flat array of IDs
          this.orderData.packages = [] // Packages to be updated (with existing IDs)
          this.newAddedPackages = [] // Packages to be added (newly created)
          let packageIdPointer = 0 // Pointer to track the next available existing package ID
          // Common details for all packages
          const commonPackageDetails = {
            fragile: this.fragileSelected.value,
            description: this.orderDescription
          }
          // Iterate through the desired package sizes and counts
          this.packageObj.packagesSizes.forEach(item => {
            if (item.count > 0) {
              for (let i = 0; i < item.count; i++) {
                if (packageIdPointer < orderPackages.length) {
                  // If there's an existing package ID available, assign it
                  this.orderData.packages.push({
                    package_id: orderPackages[packageIdPointer],
                    package_size: item.id,
                    ...commonPackageDetails
                  })
                  packageIdPointer++ // Move to the next existing package ID
                } else {
                  // If no more existing package IDs, create a new package
                  this.newAddedPackages.push({
                    package_size: item.id,
                    ...commonPackageDetails
                  })
                }
              }
            }
          })

          // Determine if new packages were added based on the newAddedPackages array
          const newPackagesWereAdded = this.newAddedPackages.length > 0

          // Send PATCH request for packages that are being updated (those with existing IDs)
          sendRequest(true, false, this, 'api/v1/packages/', 'patch', this.orderData.packages, true,
            () => {
              if (newPackagesWereAdded) {
                this.addPacakges()
              } else {
                this.updateOpenPackage()
              }
            },
            (error) => {
              common.notifyResponseError(this, error)
              this.$vs.loading.close('#packages-section-loading > .con-vs-loading')
            }
          )
        }
      })
    },
    addPacakges () {
      const packages = {
        id: this.orderData.id,
        packages: this.newAddedPackages
      }
      sendRequest(true, false, this, 'api/v1/packages/', 'post', packages, true,
        () => {
          this.updateOpenPackage()
        },
        (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#packages-section-loading > .con-vs-loading')
        }
      )
    },
    updateOpenPackage () {
      const openPackageObj = {
        is_customer_allowed_to_open_packages: this.orderData.is_customer_allowed_to_open_packages.value
      }
      sendRequest(true, false, this, `api/v1/${common.defineOrderType(this.orderData)}/${this.$route.query.order}/`, 'patch', openPackageObj, true,
        () => {
          this.$vs.notify({
            color:'success',
            title:i18nData[this.$i18n.locale]['Success'],
            text:i18nData[this.$i18n.locale]['Packages'] + i18nData[this.$i18n.locale][' has been updated successfully!'],
            position: 'top-center'
          })
          this.cancelPackageInfoEdit()
          this.$vs.loading.close('#packages-section-loading > .con-vs-loading')
        },
        (error) => {
          common.notifyResponseError(this, error)
          this.$vs.loading.close('#packages-section-loading > .con-vs-loading')
        }
      )
    },
    cancelPackageInfoEdit () {
      this.editable = false
      this.$emit('loadOrder')
    }
  },
  components: {
    ShipbluCard
  },
  created () {
    this.loadPackageSizes()
  }
}
</script>
